import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-certificate-query',
  templateUrl: './certificate-query.component.html',
  styleUrls: ['./certificate-query.component.scss']
})
export class CertificateQueryComponent {

    @Input() title: string;
    @Input() form: FormGroup;
    @Input() label: string;
    @Input() placeholder: string;
    @Input() controlName: string;
    @Input() isLoading: boolean = false;
    @Input() showClear: boolean = false;
    @Output() submit = new EventEmitter<void>();
    @Output() clear = new EventEmitter<void>();
  
    onSubmitClick(): void {
      if (this.form && this.form.invalid) { return; }
      this.submit.emit();
    }
  
    onClearClick(): void {
      this.clear.emit();
    }
}

